"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "verzegnis": {
    "10c0db9d": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "skipSearch": false
    }],
    "avons": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25fea054": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "skipSearch": false
    }],
    "duebis": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4e859746": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "skipSearch": false
    }],
    "fuignis": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1b20e090": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "skipSearch": false
    }],
    "pozzis": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "997f6bc3": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "skipSearch": false
    }],
    "riviasio": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "052797fd": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "skipSearch": false
    }],
    "sella-chianzutan": [{
      "hkey": "482a3728",
      "slug": "verzegnis",
      "name": "Verzegnis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;